import { WorkFlowStepWarningModule } from "./workFlowStepWarning/work-flow-step-warning.module";
import { ChangeCompanyStateModule } from "./changeCompanyState/change-company-state.module";
import { ModifyPlanModule } from "./modifyPlan/modify-plan.module";
import { CompanyPageComponent } from "./company-page.component";
import { ModifyPlanModalComponent } from "./modifyPlanModal/modify-plan-modal.component";
import { ChangeCompanyStateModalComponent } from "./changeCompanyStateModal/change-company-state-modal.component";
import { WorkflowStepWarningModalComponent } from "./workflowStepWarningModal/workflow-step-warning-modal.component";
import { DeleteAssessmentCredentialModalComponent } from "./deleteAssessmentCredentialModal/delete-assessment-credential-modal.component";
import { DisassociateVendorsModalComponent } from "./disassociateVendorsModal/dissassociate-vendors-modal.component";
import { ChooseJobBoardCredentialTypeModalComponent } from "./chooseJobBoardCredentialTypeModal/choose-job-board-credential-type-modal.component";
import { DeleteCompanyContactModalComponent } from "./deleteCompanyContactModal/delete-company-contact-modal";
export var CompanyPageModule = angular
    .module('companyPage', [
    WorkFlowStepWarningModule,
    ChangeCompanyStateModule,
    ModifyPlanModule,
])
    .component(CompanyPageComponent.selector, CompanyPageComponent.component)
    .component(ModifyPlanModalComponent.selector, ModifyPlanModalComponent.component)
    .component(ChangeCompanyStateModalComponent.selector, ChangeCompanyStateModalComponent.component)
    .component(WorkflowStepWarningModalComponent.selector, WorkflowStepWarningModalComponent.component)
    .component(DeleteAssessmentCredentialModalComponent.selector, DeleteAssessmentCredentialModalComponent.component)
    .component(DisassociateVendorsModalComponent.selector, DisassociateVendorsModalComponent.component)
    .component(ChooseJobBoardCredentialTypeModalComponent.selector, ChooseJobBoardCredentialTypeModalComponent.component)
    .component(DeleteCompanyContactModalComponent.selector, DeleteCompanyContactModalComponent.component)
    .directive('fileModel', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;
                element.bind('change', function () {
                    var isHeaderLogo = element[0].id == 'headerLogo';
                    var previewElement = "";
                    var imageSizeText = "";
                    if (isHeaderLogo) {
                        previewElement = document.getElementById('headerLogoPreview');
                        imageSizeText = '(1035-1045) x (335-345)';
                    }
                    else {
                        previewElement = document.getElementById('smallHeaderLogoPreview');
                        imageSizeText = '(155-165) x (45-55)';
                    }
                    var file = element[0].files[0];
                    if (!(/^image\/(png|jpe?g|gif)$/).test(file.type)) {
                        return previewElement.innerHTML = "<span class='text-danger'>Unsupported format <br>" + file.name + "</span><br>";
                    }
                    var img = new Image();
                    img.addEventListener('load', function () {
                        window.URL.revokeObjectURL(img.src); // Free some memory
                    });
                    img.src = window.URL.createObjectURL(file);
                    setTimeout(function () {
                        if ((isHeaderLogo && img.width >= 1035 && img.width <= 1045 && img.height >= 335 && img.height <= 345) || (!isHeaderLogo && img.width >= 155 && img.width <= 165 && img.height >= 45 && img.height <= 55)) {
                            previewElement.innerHTML = "";
                            scope.$apply(function () {
                                modelSetter(scope, element[0].files[0]);
                            });
                        }
                        else {
                            scope.$apply(function () {
                                modelSetter(scope, undefined);
                            });
                            previewElement.innerHTML = "<div class='text-danger'>Selected image size: " + img.width + "x" + img.height + ". Accepted size: " + imageSizeText + ".<div>";
                        }
                    }, 300);
                });
            }
        };
    }])
    .filter('unique', function () {
    return function (collection, keyName) {
        var output = [], keys = [];
        angular.forEach(collection, function (item) {
            var key = item[keyName];
            if (keys.indexOf(key) === -1) {
                keys.push(key);
                output.push(item);
            }
        });
        return output;
    };
})
    .constant('COMPANYMANAGEMENTCONSTANTS', {
    CONTROLLER: {
        ASSIGN_CLIENT_TO_STAFFING_COMPANY: 'api/company/assignclientorbu',
        GET_INDUSTRY_SUBLIST: 'api/company/getindustrysublist/',
        GET_INDUSTRY_GROUPS: 'api/company/getindustrylist',
        GET_4DOT5_ADMINS: 'api/company/get4dot5admins',
        GET_ENTITY_SCOPES: 'api/company/getentityscope',
        GET_COMPANY_TYPE_DETAILS: 'api/company/getcompanytype',
        GET_ASSESSMENT_WORK_FLOW: 'api/licensepref/getlicensepreferences/',
        GET_ASSESSMENT_WORK_FLOW_FOR_CLIENT_BU: 'api/licensepref/getclientorbulicensepreferences/',
        SET_LICENCE_PREFERENCES: 'api/licensepref/setlicensepreferences',
        SET_LICENCE_PREFERENCES_FOR_CLIENT_BU: 'api/licensepref/setclientorbulicensepreferences',
        GET_COMPANY: 'api/company/getcompanydetails',
        SAVE_COMPANY: 'api/company/savecompany',
        // DELETE_COMPANY: 'api/company/deletecompanyorclientorbu',
        // GET_DELETE_COMPANY_INFO: 'api/company/companyorclientorbudeleteinfos',
        UPDATE_COMPANY_FOR_FOURDOTFIVE_ADMIN: 'api/user/updatecompanyfor4dot5admin',
        CHANGE_COMPANYSTATE: 'api/company/changecompanystate',
        GET_ALL_SOURCE_TYPES: 'api/resume/resumesourcetypes'
    }
}).config(['$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('missioncontrol.companymanagement', {
            url: '/companymanagement',
            component: CompanyPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                companyObject: null,
                userId: null,
                accessMode: null,
                addClient: null,
                updateClient: null,
                bu: null,
                clientOrBuObject: null,
                selectedCompanyId: null,
                isAssociatedClient: null,
                vendorId: null
            }
        });
    }
])
    .name;
//# sourceMappingURL=company-page.module.js.map